<template>
  <div>
  <div
    class="reg-contact-card mb-3"
    :class="{ 'reg-contact-card-dark': isDarkMode }"
  >
    <span class="reg-contact-label">Potvrzovaná e-mailová adresa</span>
    <span class="reg-contact-label">Potvrzované číslo pro SMS</span>
    <span class="reg-contact-value">{{ contact.UserEmail || "—" }}</span>
    <span class="reg-contact-value">{{ formattedPhone }}</span>
  </div>
  <div
    class="card border-0 shadow-sm rounded-4 reg-card"
    :class="{ 'reg-card-dark': isDarkMode }"
  >
    <form @submit.prevent="submitForm" class="reg-form">
      <div class="reg-card-head">
        <h5 class="mb-0">Doplň údaje k účtu</h5>
      </div>

      <div class="reg-form-row">
        <div class="reg-field" style="flex:1 1 0;width:50%;min-width:0;">
          <label>Jméno</label>
          <input
            ref="firstnameInput"
            class="form-control"
            type="text"
            v-model="user.firstname"
            @input="v$.firstname.$touch"
            @blur="v$.firstname.$touch"
          />
          <span v-if="v$.firstname.$error" class="text-danger text-sm">
            {{ v$.firstname.$errors[0].$message }}
          </span>
        </div>
        <div class="reg-field" style="flex:1 1 0;width:50%;min-width:0;">
          <label>Příjmení</label>
          <input
            class="form-control"
            type="text"
            v-model="user.lastname"
            @input="v$.lastname.$touch"
            @blur="v$.lastname.$touch"
          />
          <span v-if="v$.lastname.$error" class="text-danger text-sm">
            {{ v$.lastname.$errors[0].$message }}
          </span>
        </div>
      </div>

      <div class="reg-form-row reg-form-row-spaced">
        <div class="reg-field" style="flex:1 1 0;width:50%;min-width:0;">
          <label>Ověřovací kód e-mail</label>
          <div class="otp-row">
            <v-otp-input
              ref="otpEmailInput"
              input-classes="otp-input email-code-input"
              separator="-"
              :num-inputs="6"
              :should-auto-focus="false"
              :is-input-num="true"
              input-type="number"
              @on-change="handleEmailCode"
              @on-complete="handleEmailCode"
            />
          </div>
          <span v-if="v$.emailCode.$error" class="text-danger text-sm">
            {{ v$.emailCode.$errors[0].$message }}
          </span>
        </div>
        <div class="reg-field" style="flex:1 1 0;width:50%;min-width:0;">
          <label>Ověřovací kód SMS</label>
          <div class="otp-row">
            <v-otp-input
              ref="otpSmsInput"
              input-classes="otp-input sms-code-input"
              separator="-"
              :num-inputs="6"
              :should-auto-focus="false"
              :is-input-num="true"
              @on-change="handleSMSCode"
              @on-complete="handleSMSCode"
            />
          </div>
          <span v-if="v$.smsCode.$error" class="text-danger text-sm">
            {{ v$.smsCode.$errors[0].$message }}
          </span>
        </div>
      </div>

      <div class="reg-form-row reg-form-row-spaced">
        <div class="reg-field" style="flex:1 1 0;width:50%;min-width:0;">
          <label>Heslo</label>
          <input
            class="form-control"
            type="password"
            v-model="user.password"
            @input="v$.password.$touch"
            @blur="v$.password.$touch"
            autocomplete="new-password"
          />
          <span v-if="v$.password.$error" class="text-danger text-sm">
            {{ v$.password.$errors[0].$message }}
          </span>
        </div>
        <div class="reg-field" style="flex:1 1 0;width:50%;min-width:0;">
          <label>Heslo znovu</label>
          <input
            class="form-control"
            type="password"
            v-model="user.confirmPassword"
            @input="v$.confirmPassword.$touch"
            @blur="v$.confirmPassword.$touch"
            autocomplete="off"
          />
          <span v-if="v$.confirmPassword.$error" class="text-danger text-sm">
            {{ v$.confirmPassword.$errors[0].$message }}
          </span>
        </div>
      </div>

      <div class="reg-form-row reg-form-row-spaced reg-form-actions">
        <button
          @click="store.dispatch('openModal', { title: 'Profilová fotka', view: 'CropperImage' })"
          type="button"
          class="btn rounded-pill px-3 fw-bold mb-0 flex-shrink-0"
          :class="isDarkMode ? 'howto-cta-dark' : 'btn-primary'"
        >
          {{ user.profileImg ? "Změnit fotku" : "Nahrát fotku" }}
        </button>
        <div class="reg-avatar-slot">
          <img
            v-if="user.profileImg"
            :src="user.profileImg"
            class="reg-avatar"
            alt=""
          />
        </div>
        <div class="d-flex align-items-center gap-2 ms-auto flex-shrink-0">
          <button
            type="submit"
            class="btn rounded-pill px-4 fw-bold mb-0"
            :class="isDarkMode ? 'howto-cta-dark' : 'btn-primary'"
            :disabled="isButtonLoading"
          >
            <span v-if="isButtonLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Dokončit registraci
          </button>
          <button
            @click="$router.push({ path: '/' })"
            type="button"
            class="btn btn-outline-primary rounded-pill px-4 mb-0"
          >
            Storno
          </button>
        </div>
      </div>
    </form>
  </div>
  </div>
  <base-modal v-if="store.state.modal.isOpen && store.state.modal.view === 'CropperImage'">
    <cropper-card @cropped-img-data="setCroppedImageData" />
  </base-modal>
</template>
<script setup>
import { ref, reactive, computed, inject, onMounted, nextTick, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useVuelidate } from "@vuelidate/core";
import { required, helpers, sameAs, minLength, maxLength } from "@vuelidate/validators";
import VOtpInput from "vue3-otp-input";
import BaseModal from "@/components/BaseModal.vue";
import CropperCard from "./CropperCard.vue";
import authService from "@/services/authService";
import dataService from "@/services/dataService";

const store = useStore();
const router = useRouter();
const route = useRoute();
const swal = inject("$swal");
const isDarkMode = computed(() => !!store.state.isDarkMode);

const otpEmailInput = ref(null);
const otpSmsInput = ref(null);
const firstnameInput = ref(null);

const initialState = {
  firstname: null,
  lastname: null,
  profileImgData: null,
  profileImg: null,
  emailCode: null,
  smsCode: null,
  password: null,
  confirmPassword: null,
};

const user = reactive({ ...initialState });
const contact = reactive({ UserEmail: "", UserPhone: "" });
const formattedPhone = computed(() => {
  const digits = String(contact.UserPhone || "").replace(/\D/g, "");
  if (digits.length === 9) {
    return `${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 9)}`;
  }
  return contact.UserPhone || "—";
});
const isButtonLoading = computed(() => store.getters["loadingModule/isButtonLoading"]);
const token = computed(() => {
  const raw = route.query.token;
  return Array.isArray(raw) ? raw[0] : raw;
});
const code = computed(() => route.query.code);

const showErrorPopup = (errorMessage, goHome = false) => {
  swal.fire({
    position: "center",
    icon: "error",
    html: Array.isArray(errorMessage)
      ? errorMessage.map((message) => `<h5>${message}</h5>`).join("")
      : `<h5>${errorMessage || "Registrace neexistuje."}</h5>`,
    showConfirmButton: false,
    timer: 3000,
    willClose: () => {
      if (goHome) router.push("/");
    },
  });
};

const loadContact = async () => {
  contact.UserEmail = "";
  contact.UserPhone = "";
  if (!token.value) {
    showErrorPopup("Token neexistuje.", true);
    return;
  }
  try {
    const response = await dataService.GetRegistration(token.value);
    if (!response?.Result) {
      showErrorPopup(response?.ErrorMessage || "Registrace neexistuje.", true);
      return;
    }
    const data = Array.isArray(response.Data) ? response.Data[0] : response.Data;
    if (!data || typeof data !== "object") {
      showErrorPopup("Registrace neexistuje.", true);
      return;
    }
    contact.UserEmail = data.UserEmail || data.useremail || "";
    contact.UserPhone = data.UserPhone || data.userphone || "";
  } catch (e) {
    console.log(e);
    showErrorPopup("Registraci se nepodařilo načíst.", true);
  }
};

const rules = computed(() => {
  return {
    firstname: {
      required: helpers.withMessage("Zadej své jméno!", required),
      maxLength: helpers.withMessage("Maximální délka je 50 znaků", maxLength(50)),
    },
    lastname: {
      required: helpers.withMessage("Zadej své příjmení!", required),
      maxLength: helpers.withMessage("Maximální délka je 50 znaků", maxLength(50)),
    },
    emailCode: {
      required: helpers.withMessage("Zadej ověřovací kód z emailu!", required),
      minLength: helpers.withMessage("Zadej ověřovací kód z emailu!", minLength(6)),
    },
    smsCode: {
      required: helpers.withMessage("Zadej ověřovací kód z SMS!", required),
      minLength: helpers.withMessage("Zadej ověřovací kód z SMS!", minLength(6)),
    },
    password: {
      required: helpers.withMessage("Zadej heslo!", required),
      minLength: helpers.withMessage("Heslo musí obsahovat alespoň 6 znaků", minLength(6)),
      containsPasswordRequirement: helpers.withMessage(
        () => "Heslo musí obsahovat kombinaci velkých písmen, malých písmen a číslice",
        (value) => /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(value)
      ),
    },
    confirmPassword: {
      sameAs: helpers.withMessage("Hesla se musí shodovat!", sameAs(user.password)),
    },
  };
});

const v$ = useVuelidate(rules, user);

const setCroppedImageData = (data) => {
  user.profileImgData = data;
  user.profileImg = data.imgUrl;
};

const setEmailCode = async () => {
  const inputs = document.querySelectorAll(".email-code-input");
  const codeArray = Array.from(code.value || "", String);
  if (inputs.length > 0 && codeArray.length === 6) {
    inputs.forEach((input, index) => {
      input.value = codeArray[index];
      input.dispatchEvent(new Event("input"));
    });
  }
};
const handleEmailCode = (value) => {
  user.emailCode = value;
};
const handleSMSCode = (value) => {
  user.smsCode = value;
};

const submitForm = async () => {
  const isFormCorrect = await v$.value.$validate();
  if (!isFormCorrect) return;

  try {
    store.dispatch("loadingModule/setButtonLoading", true);
    const response = await authService.UserRegConfirm(user, token.value);

    swal.fire({
      position: "center",
      icon: response.Result ? "success" : "error",
      html: response.Result
        ? `<h5>${response.InfoMessage[0]}</h5>` + `<p>${response.InfoMessage[1]}</p>`
        : Array.isArray(response.ErrorMessage)
          ? response.ErrorMessage.map((message) => `<h5>${message}</h5>`).join("")
          : `<h5>${response.ErrorMessage}</h5>`,
      showConfirmButton: false,
      timer: 3000,
      willClose: () => {
        if (response.Result) {
          router.push("/");
        }
      },
    });
  } catch (error) {
    console.log(error);
  } finally {
    store.dispatch("loadingModule/setButtonLoading", false);
  }
};

onMounted(async () => {
  await loadContact();
  setEmailCode();
  await nextTick();
  firstnameInput.value?.focus();
  setTimeout(() => firstnameInput.value?.focus(), 50);
});

watch(token, loadContact);
</script>
<style scoped>
.reg-contact-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;
  column-gap: 0.75rem;
  row-gap: 0.2rem;
  padding: 0.7rem 0.95rem;
  background: #ffffff;
  border-radius: 0.65rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.06);
}
.reg-contact-label {
  font-size: 0.72rem;
  font-weight: 600;
  color: #64748B;
  line-height: 1.2;
  min-width: 0;
}
.reg-contact-value {
  font-size: 1.05rem;
  font-weight: 800;
  color: #FF6B21;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.reg-contact-card-dark {
  background: #0F172A !important;
  border: 1px solid #334155 !important;
  box-shadow: none;
}
.reg-contact-card-dark .reg-contact-label {
  color: #94A3B8;
}
.reg-contact-card-dark .reg-contact-value {
  color: #FF8A4C;
}
.reg-card {
  background: #ffffff;
  border-radius: 0.65rem !important;
  width: 100%;
}
.reg-card-dark {
  background: #0F172A !important;
  border: 1px solid #334155 !important;
  color: #E2E8F0;
}
.reg-form {
  display: flex;
  flex-direction: column;
  gap: 1.9rem;
  padding: 1.5rem 1.25rem 1.65rem;
}
.reg-card-head {
  margin-bottom: 0;
}
.reg-form-row {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  gap: 0.75rem;
  width: 100%;
}
.reg-form-row-spaced {
  margin-top: 0;
  padding-top: 0.15rem;
}
.reg-form-actions {
  align-items: center;
  gap: 0.5rem;
}
.reg-card-head h5 {
  font-weight: 700;
  font-size: 1.05rem;
  color: #212529;
}
.reg-card-dark .reg-card-head h5 {
  color: #E2E8F0;
}
.reg-field {
  min-width: 0;
}
.reg-field label {
  display: block;
  font-size: 0.78rem;
  font-weight: 600;
  margin-bottom: 0.3rem;
  color: #334155;
}
.reg-card-dark .reg-field label {
  color: #CBD5E1;
}
.reg-card-dark :deep(.form-control) {
  background: #1E293B !important;
  border-color: #64748B !important;
  color: #E2E8F0 !important;
}
.reg-avatar-slot {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
}
.reg-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #FF8A4C;
}
.otp-row {
  width: auto;
}
.otp-row :deep(div) {
  display: flex !important;
  flex-wrap: nowrap !important;
  align-items: center;
  width: auto !important;
  gap: 0 !important;
}
.otp-row :deep(.otp-input) {
  flex: none !important;
  width: 30px !important;
  min-width: 30px !important;
  max-width: 30px !important;
  height: 36px !important;
  margin: 0 !important;
  padding: 0 !important;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.1;
}
.otp-row :deep(span) {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  margin: 0 !important;
  padding: 0 1px !important;
  font-weight: 600;
  font-size: 0.75rem;
  line-height: 1;
  color: #94A3B8;
}
.reg-card-dark :deep(.otp-input) {
  background-color: #1E293B;
  color: #E2E8F0;
  border: 1px solid #64748B;
}
.reg-card-dark :deep(.otp-input:focus) {
  border-color: #FF8A4C;
  background-color: #0F172A;
}
.howto-cta-dark {
  background: #FF8A4C !important;
  border: none !important;
  color: #0F172A !important;
}
.reg-card-dark .btn-outline-primary {
  color: #FF8A4C;
  border-color: #FF8A4C;
}
</style>
